webpackJsonp([1],{

/***/ 121:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MenuPage__ = __webpack_require__(290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util__ = __webpack_require__(37);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: "app-page",
  props: ['title'],
  components: { MenuPage: __WEBPACK_IMPORTED_MODULE_2__MenuPage__["a" /* default */] },
  data: function data() {
    return { showMenu: false };
  },
  methods: {
    onMenu: function onMenu(link) {
      if (link === "/logout") {
        localStorage.removeItem("credentials");
        this.$api.logout();
        this.$store.authenticated = false;
        this.$router.replace("/");
      } else {
        this.$router.push(link);
      }
      this.showMenu = false;
    },
    saveChanges: function saveChanges() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var added, removed, result, i, _i;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                added = _this.$store.addedLabels.map(function (i) {
                  return {
                    label: i.label,
                    product: i.product,
                    displayType: i.displayType
                  };
                });
                removed = _this.$store.removedLabels.map(function (i) {
                  return i.label;
                });
                _context.next = 5;
                return _this.$api.sync({ added: added, removed: removed });

              case 5:
                result = _context.sent;

                for (i = 0; i < result.added.length; i++) {
                  added[i].error = result.added[i];
                }for (_i = 0; _i < result.removed.length; _i++) {
                  removed[_i] = {
                    label: removed[_i],
                    error: result.removed[_i]
                  };
                }
                added = added.filter(function (item) {
                  return item.error;
                });
                removed = removed.filter(function (item) {
                  return item.error;
                });
                _this.$store.addedLabels = added;
                _this.$store.removedLabels = removed;
                if (added.length > 0 || removed.length > 0) {
                  __WEBPACK_IMPORTED_MODULE_3__util__["a" /* default */].error(_this, "There were errors with the pending operations", null);
                } else {
                  __WEBPACK_IMPORTED_MODULE_3__util__["a" /* default */].info(_this, "Added " + result.added.length + " and removed " + result.removed.length + " labels.");
                  __WEBPACK_IMPORTED_MODULE_3__util__["a" /* default */].sounds.success.play();
                }
                _context.next = 18;
                break;

              case 15:
                _context.prev = 15;
                _context.t0 = _context["catch"](0);

                __WEBPACK_IMPORTED_MODULE_3__util__["a" /* default */].error(_this, "Saving changes failed", _context.t0);

              case 18:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this, [[0, 15]]);
      }))();
    }
  },
  computed: {
    hasChanges: function hasChanges() {
      return this.$store.addedLabels.length > 0 || this.$store.removedLabels.length > 0;
    }
  }
});

/***/ }),

/***/ 122:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var items = [["fa-home", "Home", "/"], ["fa-plus", "Add labels", "/add"], ["fa-minus", "Remove labels", "/del"], ["fa-tag", "Check label", "/label"], ["fa-gift", "Check product", "/product/"], ["fa-sign-out", "Logout", "/logout"]];
var menu = items.map(function (i) {
  return { icon: i[0], label: i[1], link: i[2] };
});
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'menu-page',
  data: function data() {
    return { menu: menu };
  }
});

/***/ }),

/***/ 123:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 124:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/mariella.fdbaf70.png";

/***/ }),

/***/ 125:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util__ = __webpack_require__(37);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      timer: null,
      pending: 0,
      error: null,
      pages: []
    };
  },

  created: function created() {
    this.timer = setInterval(this.updatePending, 10000);
    this.updatePending();
    this.checkPages();
  },
  beforeDestroy: function beforeDestroy() {
    clearInterval(this.timer);
  },


  methods: {
    updatePending: function updatePending() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var status;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return _this.$api.status();

              case 3:
                status = _context.sent;

                _this.pending = status.pending;
                _this.error = null;
                _context.next = 12;
                break;

              case 8:
                _context.prev = 8;
                _context.t0 = _context["catch"](0);

                _this.error = "Connection down";
                console.log("Failed to update status", _context.t0);

              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this, [[0, 8]]);
      }))();
    },
    turnPagePopup: function turnPagePopup() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var page;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this2.$ons.openActionSheet({
                  buttons: [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(_this2.pages), ["Cancel"]),
                  cancelable: true,
                  title: "Select page"
                });

              case 2:
                page = _context2.sent;

                if (!(page >= 0 && page < _this2.pages.length)) {
                  _context2.next = 13;
                  break;
                }

                __WEBPACK_IMPORTED_MODULE_3__util__["a" /* default */].info(_this2, "Turning labels to page " + _this2.pages[page]);
                _context2.prev = 5;
                _context2.next = 8;
                return _this2.$api.turnPage(page);

              case 8:
                _context2.next = 13;
                break;

              case 10:
                _context2.prev = 10;
                _context2.t0 = _context2["catch"](5);

                __WEBPACK_IMPORTED_MODULE_3__util__["a" /* default */].error(_this2, "Turning page failed", _context2.t0);

              case 13:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[5, 10]]);
      }))();
    },
    checkPages: function checkPages() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                _context3.next = 3;
                return _this3.$api.getDisplayPages();

              case 3:
                _this3.pages = _context3.sent;
                _context3.next = 9;
                break;

              case 6:
                _context3.prev = 6;
                _context3.t0 = _context3["catch"](0);

                __WEBPACK_IMPORTED_MODULE_3__util__["a" /* default */].error(_this3, "Getting display pages failed", _context3.t0);

              case 9:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this3, [[0, 6]]);
      }))();
    }
  }
});

/***/ }),

/***/ 126:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util__ = __webpack_require__(37);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      product: "",
      label: "",
      displayTypeIndex: localStorage.getObject("displayTypeIndex") || 0,
      displayTypes: [],
      enableProduct: true
    };
  },
  created: function created() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var dtypes;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.$api.getDisplayTypes();

            case 2:
              dtypes = _context.sent;

              _this.displayTypes = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(dtypes);

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  mounted: function mounted() {
    this.setFocus();
  },

  methods: {
    selectDisplayType: function selectDisplayType(i) {
      this.displayTypeIndex = i;
      localStorage.setObject("displayTypeIndex", i);
      this.setFocus();
    },
    setFocus: function setFocus() {
      __WEBPACK_IMPORTED_MODULE_3__util__["a" /* default */].focus(this.enableProduct ? "product" : "label");
    },
    removeItem: function removeItem(label) {
      this.$store.addedLabels = this.$store.addedLabels.filter(function (item) {
        return item.label !== label;
      });
      this.setFocus();
    },
    enterLabel: function enterLabel(evt) {
      var _this2 = this;

      evt.preventDefault();
      if (this.labelIsValid) {
        this.$store.addedLabels = this.$store.addedLabels.filter(function (item) {
          return item.label !== _this2.label;
        });
        this.$store.addedLabels.splice(0, 0, {
          label: this.label,
          product: this.product,
          displayType: this.displayTypes[this.displayTypeIndex].id,
          error: false
        });
        if (this.enableProduct) {
          this.product = "";
          document.getElementById("product").focus();
        }
        __WEBPACK_IMPORTED_MODULE_3__util__["a" /* default */].sounds.success.play();
      } else {
        __WEBPACK_IMPORTED_MODULE_3__util__["a" /* default */].warn(this, "Invalid label: " + this.label, null);
      }
      this.label = "";
    },
    enterProduct: function enterProduct(evt) {
      evt.preventDefault();
      if (this.product.length > 0) {
        document.getElementById("label").focus();
      }
    }
  },
  computed: {
    labelIsValid: function labelIsValid() {
      return __WEBPACK_IMPORTED_MODULE_3__util__["a" /* default */].validateLabel(this.label);
    }
  }
});

/***/ }),

/***/ 127:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util__ = __webpack_require__(37);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return { label: "" };
  },
  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_0__util__["a" /* default */].focus("label");
  },
  methods: {
    removeItem: function removeItem(l) {
      this.$store.removedLabels = this.$store.removedLabels.filter(function (item) {
        return item.label !== l;
      });
      __WEBPACK_IMPORTED_MODULE_0__util__["a" /* default */].focus("label");
    },
    addLabel: function addLabel(evt) {
      var _this = this;

      evt.preventDefault();
      if (this.labelIsValid) {
        this.$store.removedLabels = this.$store.removedLabels.filter(function (item) {
          return item.label !== _this.label;
        });
        this.$store.removedLabels.splice(0, 0, {
          label: this.label,
          error: false
        });
        __WEBPACK_IMPORTED_MODULE_0__util__["a" /* default */].sounds.success.play();
      } else {
        __WEBPACK_IMPORTED_MODULE_0__util__["a" /* default */].warn(this, "Invalid label: " + this.label, null);
      }
      this.label = "";
    }
  },
  computed: {
    labelIsValid: function labelIsValid() {
      return __WEBPACK_IMPORTED_MODULE_0__util__["a" /* default */].validateLabel(this.label);
    }
  }
});

/***/ }),

/***/ 128:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_js__ = __webpack_require__(37);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      labelInput: "",
      loading: false,
      label: null,
      timer: null
    };
  },
  mounted: function mounted() {
    document.addEventListener("click", this.focus);
    this.focus();
    this.load();
    this.timer = setInterval(this.load, 5000);
  },
  beforeDestroy: function beforeDestroy() {
    document.removeEventListener("click", this.focus);
    clearInterval(this.timer);
  },

  watch: { "$route": "load" },
  methods: {
    focus: function focus() {
      __WEBPACK_IMPORTED_MODULE_2__util_js__["a" /* default */].focus("label");
    },
    lookup: function lookup(evt) {
      evt.preventDefault();
      if (__WEBPACK_IMPORTED_MODULE_2__util_js__["a" /* default */].validateLabel(this.labelInput)) {
        this.$router.push("/label/" + this.labelInput);
      } else {
        __WEBPACK_IMPORTED_MODULE_2__util_js__["a" /* default */].warn(this, "Invalid label: " + this.labelInput);
      }
      this.labelInput = "";
    },
    load: function load() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var id, label;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                id = _this.$route.params.id;

                if (id) {
                  _context.next = 5;
                  break;
                }

                _this.loading = false;
                _this.label = null;
                return _context.abrupt("return");

              case 5:
                _this.loading = true;
                _context.prev = 6;
                _context.next = 9;
                return _this.$api.getLabel(id);

              case 9:
                label = _context.sent;

                if (!label) {
                  _context.next = 22;
                  break;
                }

                if (!label.productId) {
                  _context.next = 15;
                  break;
                }

                _context.next = 14;
                return _this.$api.getProduct(label.productId);

              case 14:
                label.product = _context.sent;

              case 15:
                if (!label.locationId) {
                  _context.next = 19;
                  break;
                }

                _context.next = 18;
                return _this.$api.getLocation(label.locationId);

              case 18:
                label.location = _context.sent;

              case 19:
                _this.label = label;
                _context.next = 24;
                break;

              case 22:
                __WEBPACK_IMPORTED_MODULE_2__util_js__["a" /* default */].warn(_this, "Label " + id + " not found.");
                _this.$router.replace("/label");

              case 24:
                _context.next = 30;
                break;

              case 26:
                _context.prev = 26;
                _context.t0 = _context["catch"](6);

                __WEBPACK_IMPORTED_MODULE_2__util_js__["a" /* default */].error(_this, "Getting label details failed", _context.t0);
                _this.$router.replace("/label");

              case 30:
                _context.prev = 30;

                _this.loading = false;
                return _context.finish(30);

              case 33:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this, [[6, 26, 30, 33]]);
      }))();
    },
    batteryIcon: function batteryIcon(label) {
      return "fa-battery-" + (label.batteryStatus ? "full" : "empty");
    },
    updateLabel: function updateLabel() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this2.$api.updateLabel(_this2.label.id);

              case 2:
                _this2.load();

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    }
  }
});

/***/ }),

/***/ 129:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_js__ = __webpack_require__(37);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      eanInput: "",
      product: null,
      loading: false,
      dataFields: []
    };
  },
  mounted: function mounted() {
    document.addEventListener("click", this.focus);
    this.loadDisplayFields();
    this.load();
  },
  beforeDestroy: function beforeDestroy() {
    document.removeEventListener("click", this.focus);
  },


  watch: { "$route": "load" },

  methods: {
    focus: function focus() {
      __WEBPACK_IMPORTED_MODULE_4__util_js__["a" /* default */].focus("product");
    },
    lookup: function lookup(evt) {
      evt.preventDefault();
      if (this.eanInput) {
        this.$router.push("/product/" + this.eanInput);
      }
    },
    loadDisplayFields: function loadDisplayFields() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var fields;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return _this.$api.getDisplayFields();

              case 3:
                fields = _context.sent;

                _this.dataFields = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values___default()(fields).map(function (a) {
                  return a[0];
                });
                _context.next = 10;
                break;

              case 7:
                _context.prev = 7;
                _context.t0 = _context["catch"](0);

                __WEBPACK_IMPORTED_MODULE_4__util_js__["a" /* default */].error(_this, "Failed to load display fields.", _context.t0);

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this, [[0, 7]]);
      }))();
    },
    load: function load() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var ean, product;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.eanInput = "";
                ean = _this2.$route.params.id;

                if (ean) {
                  _context2.next = 7;
                  break;
                }

                _this2.focus();
                _this2.loading = false;
                _this2.product = null;
                return _context2.abrupt("return");

              case 7:
                _this2.loading = true;
                _context2.prev = 8;
                _context2.next = 11;
                return _this2.$api.getProductByEan(ean);

              case 11:
                product = _context2.sent;

                if (!(product !== null)) {
                  _context2.next = 20;
                  break;
                }

                if (!product.locationId) {
                  _context2.next = 17;
                  break;
                }

                _context2.next = 16;
                return _this2.$api.getLocation(product.locationId);

              case 16:
                product.location = _context2.sent;

              case 17:
                _this2.product = product;
                _context2.next = 22;
                break;

              case 20:
                _context2.next = 22;
                return __WEBPACK_IMPORTED_MODULE_4__util_js__["a" /* default */].warn(_this2, "Product " + ean + " not found.");

              case 22:
                _context2.next = 28;
                break;

              case 24:
                _context2.prev = 24;
                _context2.t0 = _context2["catch"](8);
                _context2.next = 28;
                return __WEBPACK_IMPORTED_MODULE_4__util_js__["a" /* default */].error(_this2, "Failed to get product details.", _context2.t0);

              case 28:
                _context2.prev = 28;

                _this2.loading = false;
                return _context2.finish(28);

              case 31:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[8, 24, 28, 31]]);
      }))();
    },
    fieldValue: function fieldValue(field) {
      var value = this.product.data[field.name];
      if (field.units && field.units.length) {
        var unit = this.product.data[field.name + "_UNIT"];
        if (unit) {
          var _iteratorNormalCompletion = true;
          var _didIteratorError = false;
          var _iteratorError = undefined;

          try {
            for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(field.units), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
              var u = _step.value;

              if (u.name === unit) {
                return value + " " + u.displayName;
              }
            }
          } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
              }
            } finally {
              if (_didIteratorError) {
                throw _iteratorError;
              }
            }
          }

          return value + " " + unit;
        }
      }
      return value;
    }
  }
});

/***/ }),

/***/ 131:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util__ = __webpack_require__(37);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: "login-page",
  data: function data() {
    return { username: "", password: "" };
  },

  methods: {
    login: function login() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var credentials;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                credentials = { username: _this.username, password: _this.password };
                _context.next = 4;
                return _this.$api.login(credentials);

              case 4:
                localStorage.setObject("credentials", credentials);
                _this.$store.authenticated = true;
                _context.next = 11;
                break;

              case 8:
                _context.prev = 8;
                _context.t0 = _context["catch"](0);

                __WEBPACK_IMPORTED_MODULE_2__util__["a" /* default */].warn(_this, "Authentication failed", _context.t0);

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this, [[0, 8]]);
      }))();
    }
  }
});

/***/ }),

/***/ 132:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_values__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_font_awesome_css_font_awesome_css__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_font_awesome_css_font_awesome_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_font_awesome_css_font_awesome_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_onsenui_css_onsenui_core_css__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_onsenui_css_onsenui_core_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_onsenui_css_onsenui_core_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_onsenui_css_onsen_css_components_css__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_onsenui_css_onsen_css_components_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_onsenui_css_onsen_css_components_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_router__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_onsenui_esm__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__vue_onsen_components__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__pages_HomePage__ = __webpack_require__(296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__pages_AddPage__ = __webpack_require__(300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__pages_DelPage__ = __webpack_require__(303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__pages_LabelPage__ = __webpack_require__(306);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__pages_ProductPage__ = __webpack_require__(309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__pages_LoginPage__ = __webpack_require__(314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__pages_SplashPage__ = __webpack_require__(317);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__api__ = __webpack_require__(320);





// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.


















__WEBPACK_IMPORTED_MODULE_8_vue__["a" /* default */].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_8_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_9_vue_router__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_8_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_10_vue_onsenui_esm__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_values___default()(__WEBPACK_IMPORTED_MODULE_11__vue_onsen_components__).forEach(function (comp) {
  return __WEBPACK_IMPORTED_MODULE_8_vue__["a" /* default */].component(comp.name, comp);
});

var router = new __WEBPACK_IMPORTED_MODULE_9_vue_router__["a" /* default */]({
  routes: [{ path: "/", component: __WEBPACK_IMPORTED_MODULE_12__pages_HomePage__["a" /* default */] }, { path: "/add", component: __WEBPACK_IMPORTED_MODULE_13__pages_AddPage__["a" /* default */] }, { path: "/del", component: __WEBPACK_IMPORTED_MODULE_14__pages_DelPage__["a" /* default */] }, { path: "/label", component: __WEBPACK_IMPORTED_MODULE_15__pages_LabelPage__["a" /* default */] }, { path: "/label/:id", component: __WEBPACK_IMPORTED_MODULE_15__pages_LabelPage__["a" /* default */] }, { path: "/product", component: __WEBPACK_IMPORTED_MODULE_16__pages_ProductPage__["a" /* default */] }, { path: "/product/:id", component: __WEBPACK_IMPORTED_MODULE_16__pages_ProductPage__["a" /* default */] }]
});

__WEBPACK_IMPORTED_MODULE_8_vue__["a" /* default */].prototype.$store = new __WEBPACK_IMPORTED_MODULE_8_vue__["a" /* default */]({
  data: function data() {
    return {
      authenticated: false,
      addedLabels: [],
      removedLabels: []
    };
  }
});

var baseUrl = window.location.protocol + "//" + window.location.host + "/api/mobile/";
__WEBPACK_IMPORTED_MODULE_8_vue__["a" /* default */].prototype.$api = new __WEBPACK_IMPORTED_MODULE_19__api__["a" /* default */](baseUrl);

__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()(Storage.prototype, {
  setObject: function setObject(key, value) {
    this.setItem(key, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(value));
  },
  getObject: function getObject(key) {
    var s = this.getItem(key);
    return s !== null ? JSON.parse(s) : null;
  }
});

new __WEBPACK_IMPORTED_MODULE_8_vue__["a" /* default */]({
  el: "#app",
  router: router,
  data: function data() {
    return { initialized: false };
  },
  render: function render(h) {
    if (!this.initialized) return h(__WEBPACK_IMPORTED_MODULE_18__pages_SplashPage__["a" /* default */]);
    if (!this.$store.authenticated) return h(__WEBPACK_IMPORTED_MODULE_17__pages_LoginPage__["a" /* default */]);
    return h("router-view");
  },
  created: function created() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var credentials;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              credentials = localStorage.getObject("credentials");

              if (!credentials) {
                _context.next = 6;
                break;
              }

              _context.next = 5;
              return _this.$api.login(credentials);

            case 5:
              _this.$store.authenticated = true;

            case 6:
              _context.next = 12;
              break;

            case 8:
              _context.prev = 8;
              _context.t0 = _context['catch'](0);

              localStorage.removeItem("credentials");
              util.error(_this, "Authentication failed", _context.t0);

            case 12:
              _context.prev = 12;

              _this.initialized = true;
              return _context.finish(12);

            case 15:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this, [[0, 8, 12, 15]]);
    }))();
  }
});

/***/ }),

/***/ 155:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 157:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 158:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 195:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_onsenui_esm_components_VOnsActionSheet__ = __webpack_require__(196);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "VOnsActionSheet", function() { return __WEBPACK_IMPORTED_MODULE_0_vue_onsenui_esm_components_VOnsActionSheet__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_onsenui_esm_components_VOnsActionSheetButton__ = __webpack_require__(219);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "VOnsActionSheetButton", function() { return __WEBPACK_IMPORTED_MODULE_1_vue_onsenui_esm_components_VOnsActionSheetButton__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_onsenui_esm_components_VOnsAlertDialog__ = __webpack_require__(221);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "VOnsAlertDialog", function() { return __WEBPACK_IMPORTED_MODULE_2_vue_onsenui_esm_components_VOnsAlertDialog__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_onsenui_esm_components_VOnsAlertDialogButton__ = __webpack_require__(224);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "VOnsAlertDialogButton", function() { return __WEBPACK_IMPORTED_MODULE_3_vue_onsenui_esm_components_VOnsAlertDialogButton__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_onsenui_esm_components_VOnsButton__ = __webpack_require__(226);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "VOnsButton", function() { return __WEBPACK_IMPORTED_MODULE_4_vue_onsenui_esm_components_VOnsButton__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_onsenui_esm_components_VOnsCard__ = __webpack_require__(228);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "VOnsCard", function() { return __WEBPACK_IMPORTED_MODULE_5_vue_onsenui_esm_components_VOnsCard__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_onsenui_esm_components_VOnsCol__ = __webpack_require__(230);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "VOnsCol", function() { return __WEBPACK_IMPORTED_MODULE_6_vue_onsenui_esm_components_VOnsCol__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_onsenui_esm_components_VOnsIcon__ = __webpack_require__(232);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "VOnsIcon", function() { return __WEBPACK_IMPORTED_MODULE_7_vue_onsenui_esm_components_VOnsIcon__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_onsenui_esm_components_VOnsInput__ = __webpack_require__(234);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "VOnsInput", function() { return __WEBPACK_IMPORTED_MODULE_8_vue_onsenui_esm_components_VOnsInput__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_onsenui_esm_components_VOnsList__ = __webpack_require__(236);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "VOnsList", function() { return __WEBPACK_IMPORTED_MODULE_9_vue_onsenui_esm_components_VOnsList__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_onsenui_esm_components_VOnsListHeader__ = __webpack_require__(238);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "VOnsListHeader", function() { return __WEBPACK_IMPORTED_MODULE_10_vue_onsenui_esm_components_VOnsListHeader__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_onsenui_esm_components_VOnsListItem__ = __webpack_require__(240);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "VOnsListItem", function() { return __WEBPACK_IMPORTED_MODULE_11_vue_onsenui_esm_components_VOnsListItem__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_onsenui_esm_components_VOnsListTitle__ = __webpack_require__(242);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "VOnsListTitle", function() { return __WEBPACK_IMPORTED_MODULE_12_vue_onsenui_esm_components_VOnsListTitle__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_onsenui_esm_components_VOnsPage__ = __webpack_require__(244);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "VOnsPage", function() { return __WEBPACK_IMPORTED_MODULE_13_vue_onsenui_esm_components_VOnsPage__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue_onsenui_esm_components_VOnsProgressBar__ = __webpack_require__(255);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "VOnsProgressBar", function() { return __WEBPACK_IMPORTED_MODULE_14_vue_onsenui_esm_components_VOnsProgressBar__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vue_onsenui_esm_components_VOnsProgressCircular__ = __webpack_require__(257);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "VOnsProgressCircular", function() { return __WEBPACK_IMPORTED_MODULE_15_vue_onsenui_esm_components_VOnsProgressCircular__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_vue_onsenui_esm_components_VOnsRow__ = __webpack_require__(259);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "VOnsRow", function() { return __WEBPACK_IMPORTED_MODULE_16_vue_onsenui_esm_components_VOnsRow__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_vue_onsenui_esm_components_VOnsSegment__ = __webpack_require__(261);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "VOnsSegment", function() { return __WEBPACK_IMPORTED_MODULE_17_vue_onsenui_esm_components_VOnsSegment__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_vue_onsenui_esm_components_VOnsSelect__ = __webpack_require__(263);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "VOnsSelect", function() { return __WEBPACK_IMPORTED_MODULE_18_vue_onsenui_esm_components_VOnsSelect__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_vue_onsenui_esm_components_VOnsSplitter__ = __webpack_require__(265);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "VOnsSplitter", function() { return __WEBPACK_IMPORTED_MODULE_19_vue_onsenui_esm_components_VOnsSplitter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_vue_onsenui_esm_components_VOnsSplitterContent__ = __webpack_require__(269);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "VOnsSplitterContent", function() { return __WEBPACK_IMPORTED_MODULE_20_vue_onsenui_esm_components_VOnsSplitterContent__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_vue_onsenui_esm_components_VOnsSplitterMask__ = __webpack_require__(271);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "VOnsSplitterMask", function() { return __WEBPACK_IMPORTED_MODULE_21_vue_onsenui_esm_components_VOnsSplitterMask__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_vue_onsenui_esm_components_VOnsSplitterSide__ = __webpack_require__(273);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "VOnsSplitterSide", function() { return __WEBPACK_IMPORTED_MODULE_22_vue_onsenui_esm_components_VOnsSplitterSide__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_vue_onsenui_esm_components_VOnsSwitch__ = __webpack_require__(276);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "VOnsSwitch", function() { return __WEBPACK_IMPORTED_MODULE_23_vue_onsenui_esm_components_VOnsSwitch__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_vue_onsenui_esm_components_VOnsToast__ = __webpack_require__(279);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "VOnsToast", function() { return __WEBPACK_IMPORTED_MODULE_24_vue_onsenui_esm_components_VOnsToast__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_vue_onsenui_esm_components_VOnsToolbar__ = __webpack_require__(285);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "VOnsToolbar", function() { return __WEBPACK_IMPORTED_MODULE_25_vue_onsenui_esm_components_VOnsToolbar__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_vue_onsenui_esm_components_VOnsToolbarButton__ = __webpack_require__(286);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "VOnsToolbarButton", function() { return __WEBPACK_IMPORTED_MODULE_26_vue_onsenui_esm_components_VOnsToolbarButton__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__pages_AppPage__ = __webpack_require__(288);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "AppPage", function() { return __WEBPACK_IMPORTED_MODULE_27__pages_AppPage__["a"]; });
// Add your components:





// export { default as VOnsBackButton } from 'vue-onsenui/esm/components/VOnsBackButton'
// export { default as VOnsBottomToolbar } from 'vue-onsenui/esm/components/VOnsBottomToolbar'


// export { default as VOnsCarousel } from 'vue-onsenui/esm/components/VOnsCarousel'
// export { default as VOnsCarouselItem } from 'vue-onsenui/esm/components/VOnsCarouselItem'
// export { default as VOnsCheckbox } from 'vue-onsenui/esm/components/VOnsCheckbox'

// export { default as VOnsDialog } from 'vue-onsenui/esm/components/VOnsDialog'
// export { default as VOnsFab } from 'vue-onsenui/esm/components/VOnsFab'


// export { default as VOnsLazyRepeat } from 'vue-onsenui/esm/components/VOnsLazyRepeat'




// export { default as VOnsModal } from 'vue-onsenui/esm/components/VOnsModal'
// export { default as VOnsNavigator } from 'vue-onsenui/esm/components/VOnsNavigator'

// export { default as VOnsPopover } from 'vue-onsenui/esm/components/VOnsPopover'


// export { default as VOnsPullHook } from 'vue-onsenui/esm/components/VOnsPullHook'
// export { default as VOnsRadio } from 'vue-onsenui/esm/components/VOnsRadio'
// export { default as VOnsRange } from 'vue-onsenui/esm/components/VOnsRange'
// export { default as VOnsRipple } from 'vue-onsenui/esm/components/VOnsRipple'

// export { default as VOnsSearchInput } from 'vue-onsenui/esm/components/VOnsSearchInput'


// export { default as VOnsSpeedDial } from 'vue-onsenui/esm/components/VOnsSpeedDial'
// export { default as VOnsSpeedDialItem } from 'vue-onsenui/esm/components/VOnsSpeedDialItem'





// export { default as VOnsTab } from 'vue-onsenui/esm/components/VOnsTab'
// export { default as VOnsTabbar } from 'vue-onsenui/esm/components/VOnsTabbar'






/***/ }),

/***/ 288:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppPage_vue__ = __webpack_require__(121);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2d2cd270_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppPage_vue__ = __webpack_require__(295);
function injectStyle (ssrContext) {
  __webpack_require__(289)
}
var normalizeComponent = __webpack_require__(25)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2d2cd270"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2d2cd270_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 289:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 290:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MenuPage_vue__ = __webpack_require__(122);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bf3df99c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MenuPage_vue__ = __webpack_require__(292);
function injectStyle (ssrContext) {
  __webpack_require__(291)
}
var normalizeComponent = __webpack_require__(25)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-bf3df99c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MenuPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bf3df99c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MenuPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 291:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 292:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-ons-page',[_c('v-ons-toolbar',[_c('div',{staticClass:"center"},[_c('img',{attrs:{"id":"ellafashion-logo","src":__webpack_require__(123),"alt":"EllaFashion"}})])]),_vm._v(" "),_c('v-ons-list',_vm._l((_vm.menu),function(item){return _c('v-ons-list-item',{key:item.link,attrs:{"modifier":"chevron"},on:{"click":function($event){_vm.$emit('menu', item.link)}}},[_c('div',{staticClass:"left"},[_c('v-ons-icon',{attrs:{"fixed-width":"","icon":item.icon}})],1),_vm._v(" "),_c('div',{staticClass:"center"},[_vm._v(_vm._s(item.label))])])})),_vm._v(" "),_c('div',{staticStyle:{"text-align":"center"}},[_c('img',{attrs:{"id":"mariella-logo","src":__webpack_require__(124),"alt":"MariElla"}})])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 293:
/***/ (function(module, exports) {

module.exports = "data:audio/mpeg;base64,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"

/***/ }),

/***/ 294:
/***/ (function(module, exports) {

module.exports = "data:audio/mpeg;base64,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"

/***/ }),

/***/ 295:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-ons-splitter',[_c('v-ons-splitter-side',{attrs:{"collapse":"(max-width: 650px)","swipable":"","width":"250px","open":_vm.showMenu},on:{"update:open":function($event){_vm.showMenu=$event}}},[_c('menu-page',{on:{"menu":_vm.onMenu}})],1),_vm._v(" "),_c('v-ons-splitter-content',{attrs:{"id":"content"}},[_c('v-ons-page',[_c('v-ons-toolbar',[_c('div',{staticClass:"left"},[_c('v-ons-toolbar-button',{attrs:{"id":"menu-button"},on:{"click":function($event){_vm.showMenu = !_vm.showMenu}}},[_c('v-ons-icon',{attrs:{"icon":"fa-bars"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"center"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.hasChanges),expression:"hasChanges"}],staticClass:"right"},[_c('v-ons-toolbar-button',{on:{"click":_vm.saveChanges}},[_c('v-ons-icon',{attrs:{"icon":"fa-save"}})],1)],1)]),_vm._v(" "),_vm._t("default")],2)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 296:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HomePage_vue__ = __webpack_require__(125);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_85aeecb0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HomePage_vue__ = __webpack_require__(298);
function injectStyle (ssrContext) {
  __webpack_require__(297)
}
var normalizeComponent = __webpack_require__(25)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-85aeecb0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HomePage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_85aeecb0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HomePage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 297:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 298:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-page',{attrs:{"title":"EllaFashion"}},[_c('div',[(_vm.error)?_c('v-ons-card',{staticClass:"error"},[_vm._v("\n      "+_vm._s(_vm.error)+"\n    ")]):_vm._e(),_vm._v(" "),(_vm.pending)?_c('v-ons-card',{staticClass:"active"},[_c('img',{staticStyle:{"float":"left","margin-top":"-4px","max-height":"1.5rem"},attrs:{"src":__webpack_require__(299)}}),_vm._v(" "),_c('span',{staticStyle:{"margin-left":"-1.5rem"}},[_vm._v(_vm._s(_vm.pending)+" pending updates")])]):_vm._e(),_vm._v(" "),_c('v-ons-card',[_c('v-ons-button',{on:{"click":function($event){_vm.$router.push('/add')}}},[_vm._v("Add labels")]),_vm._v(" "),_c('v-ons-button',{on:{"click":function($event){_vm.$router.push('/del')}}},[_vm._v("Remove labels")]),_vm._v(" "),_c('v-ons-button',{on:{"click":function($event){_vm.$router.push('/label')}}},[_vm._v("Check label")]),_vm._v(" "),_c('v-ons-button',{on:{"click":function($event){_vm.$router.push('/product/')}}},[_vm._v("Check product")]),_vm._v(" "),(this.pages.length > 1)?_c('v-ons-button',{on:{"click":function($event){_vm.turnPagePopup()}}},[_vm._v("Turn page")]):_vm._e()],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 299:
/***/ (function(module, exports) {

module.exports = "data:image/gif;base64,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"

/***/ }),

/***/ 300:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddPage_vue__ = __webpack_require__(126);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3caa8f80_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddPage_vue__ = __webpack_require__(302);
function injectStyle (ssrContext) {
  __webpack_require__(301)
}
var normalizeComponent = __webpack_require__(25)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3caa8f80"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3caa8f80_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 301:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 302:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-page',{attrs:{"title":"Add Labels"}},[_c('v-ons-list',[_c('v-ons-list-header',[_vm._v("Enter product and label")]),_vm._v(" "),(_vm.displayTypes.length > 1)?_c('v-ons-list-item',[_c('v-ons-segment',{staticStyle:{"width":"100%"},attrs:{"index":_vm.displayTypeIndex},on:{"update:index":_vm.selectDisplayType}},_vm._l((_vm.displayTypes),function(dt){return _c('button',{key:dt.id},[_vm._v(_vm._s(dt.id))])}))],1):_vm._e(),_vm._v(" "),_c('v-ons-list-item',[_c('div',{staticClass:"center"},[_c('v-ons-input',{attrs:{"disable-auto-styling":"","placeholder":"Product","input-id":"product","disabled":!_vm.enableProduct},on:{"keydown":[function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.enterProduct($event)},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"tab",9,$event.key,"Tab")){ return null; }return _vm.enterProduct($event)}]},model:{value:(_vm.product),callback:function ($$v) {_vm.product=$$v},expression:"product"}})],1),_vm._v(" "),_c('div',{staticClass:"right"},[_c('v-ons-switch',{attrs:{"disabled":!_vm.product},model:{value:(_vm.enableProduct),callback:function ($$v) {_vm.enableProduct=$$v},expression:"enableProduct"}})],1)]),_vm._v(" "),_c('v-ons-list-item',[_c('v-ons-input',{attrs:{"disable-auto-styling":"","placeholder":"Label","input-id":"label","disabled":!_vm.product},on:{"keydown":[function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.enterLabel($event)},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"tab",9,$event.key,"Tab")){ return null; }return _vm.enterLabel($event)}]},model:{value:(_vm.label),callback:function ($$v) {_vm.label=$$v},expression:"label"}})],1)],1),_vm._v(" "),_c('v-ons-list',{directives:[{name:"show",rawName:"v-show",value:(!!_vm.$store.addedLabels.length),expression:"!!$store.addedLabels.length"}]},[_c('v-ons-list-header',[_vm._v("Labels to be added")]),_vm._v(" "),_vm._l((_vm.$store.addedLabels),function(item){return _c('v-ons-list-item',{key:item.label},[_c('div',{staticClass:"center label-item"},[_vm._v("\n        "+_vm._s(item.label)+"\n        → \n        "),_c('span',{class:{ error: item.error }},[_vm._v(_vm._s(item.product))])]),_vm._v(" "),_c('div',{staticClass:"right"},[_c('v-ons-icon',{staticClass:"remove-icon",attrs:{"icon":"fa-times-circle"},on:{"click":function($event){_vm.removeItem(item.label)}}})],1)])})],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 303:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DelPage_vue__ = __webpack_require__(127);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2be5edd5_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DelPage_vue__ = __webpack_require__(305);
function injectStyle (ssrContext) {
  __webpack_require__(304)
}
var normalizeComponent = __webpack_require__(25)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2be5edd5"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DelPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2be5edd5_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DelPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 304:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 305:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-page',{attrs:{"title":"Remove Labels"}},[_c('v-ons-list',[_c('v-ons-list-header',[_vm._v("Enter label")]),_vm._v(" "),_c('v-ons-list-item',[_c('v-ons-input',{attrs:{"disable-auto-styling":"","input-id":"label","placeholder":"Label"},on:{"keydown":[function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.addLabel($event)},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"tab",9,$event.key,"Tab")){ return null; }return _vm.addLabel($event)}]},model:{value:(_vm.label),callback:function ($$v) {_vm.label=$$v},expression:"label"}})],1)],1),_vm._v(" "),_c('v-ons-list',{directives:[{name:"show",rawName:"v-show",value:(!!_vm.$store.removedLabels.length),expression:"!!$store.removedLabels.length"}]},[_c('v-ons-list-header',[_vm._v("Labels to be removed")]),_vm._v(" "),_vm._l((_vm.$store.removedLabels),function(item){return _c('v-ons-list-item',{key:item.label},[_c('div',{staticClass:"center label-item"},[_c('span',{class:{ error: item.error }},[_vm._v(_vm._s(item.label))])]),_vm._v(" "),_c('div',{staticClass:"right"},[_c('v-ons-icon',{staticClass:"remove-icon",attrs:{"icon":"fa-times-circle"},on:{"click":function($event){_vm.removeItem(item.label)}}})],1)])})],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 306:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LabelPage_vue__ = __webpack_require__(128);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_687e8b23_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LabelPage_vue__ = __webpack_require__(308);
function injectStyle (ssrContext) {
  __webpack_require__(307)
}
var normalizeComponent = __webpack_require__(25)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-687e8b23"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LabelPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_687e8b23_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LabelPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 307:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 308:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-page',{attrs:{"title":"Check Label"}},[_c('div',[_c('v-ons-list',[_c('v-ons-list-header',[_vm._v("Enter label")]),_vm._v(" "),_c('v-ons-list-item',[_c('div',{staticClass:"center"},[_c('v-ons-input',{attrs:{"disable-auto-styling":"","input-id":"label","placeholder":"Label"},on:{"keyup":[function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.lookup($event)},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"tab",9,$event.key,"Tab")){ return null; }return _vm.lookup($event)}]},model:{value:(_vm.labelInput),callback:function ($$v) {_vm.labelInput=$$v},expression:"labelInput"}})],1),_vm._v(" "),_c('div',{staticClass:"right"},[(_vm.loading)?_c('v-ons-progress-circular',{attrs:{"indeterminate":""}}):_vm._e()],1)])],1),_vm._v(" "),(!!_vm.label)?_c('v-ons-list',[_c('v-ons-list-header',[_vm._v("Label information")]),_vm._v(" "),_c('v-ons-list-item',[_c('div',{staticClass:"center label"},[_vm._v("Label")]),_vm._v(" "),_c('div',{staticClass:"right"},[_vm._v(_vm._s(_vm.label.id))])]),_vm._v(" "),_c('v-ons-list-item',[_c('div',{staticClass:"center label"},[_vm._v("Type")]),_vm._v(" "),_c('div',{staticClass:"right"},[_vm._v(_vm._s(_vm.label.displayType))])]),_vm._v(" "),_c('v-ons-list-item',[_c('div',{staticClass:"center label"},[_vm._v("Status")]),_vm._v(" "),_c('div',{staticClass:"right"},[_c('span',{staticClass:"status",class:_vm.label.status},[_vm._v(_vm._s(_vm.label.status))])])]),_vm._v(" "),_c('v-ons-list-item',[_c('div',{staticClass:"center label"},[_vm._v("Battery")]),_vm._v(" "),_c('div',{staticClass:"right"},[_c('v-ons-icon',{attrs:{"icon":_vm.batteryIcon(_vm.label)}})],1)]),_vm._v(" "),(_vm.label.product)?[_c('v-ons-list-item',[_c('div',{staticClass:"center label"},[_vm._v("Product EAN")]),_vm._v(" "),_c('div',{staticClass:"right"},[_c('router-link',{attrs:{"to":("/product/" + (_vm.label.product.ean))}},[_vm._v(_vm._s(_vm.label.product.ean))])],1)]),_vm._v(" "),(_vm.label.product.foreignId)?_c('v-ons-list-item',[_c('div',{staticClass:"center label"},[_vm._v("Article number")]),_vm._v(" "),_c('div',{staticClass:"right"},[_vm._v(_vm._s(_vm.label.product.foreignId))])]):_vm._e(),_vm._v(" "),_c('v-ons-list-item',[_c('div',{staticClass:"center label"},[_vm._v("Product Name")]),_vm._v(" "),_c('div',{staticClass:"right"},[_vm._v(_vm._s(_vm.label.product.productName))])])]:_vm._e()],2):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"text-align":"right"}},[(_vm.label)?_c('v-ons-button',{staticStyle:{"margin":"0.5rem"},on:{"click":_vm.updateLabel}},[_vm._v("\n        Update\n      ")]):_vm._e()],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 309:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductPage_vue__ = __webpack_require__(129);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_020298f2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductPage_vue__ = __webpack_require__(313);
function injectStyle (ssrContext) {
  __webpack_require__(310)
}
var normalizeComponent = __webpack_require__(25)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-020298f2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_020298f2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 310:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 313:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-page',{attrs:{"title":"Check Product"}},[_c('div',[_c('v-ons-list',[_c('v-ons-list-header',[_vm._v("Enter product")]),_vm._v(" "),_c('v-ons-list-item',[_c('div',{staticClass:"center"},[_c('v-ons-input',{attrs:{"disable-auto-styling":"","input-id":"product","placeholder":"Product"},on:{"keyup":[function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.lookup($event)},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"tab",9,$event.key,"Tab")){ return null; }return _vm.lookup($event)}]},model:{value:(_vm.eanInput),callback:function ($$v) {_vm.eanInput=$$v},expression:"eanInput"}})],1),_vm._v(" "),_c('div',{staticClass:"right"},[(_vm.loading)?_c('v-ons-progress-circular',{attrs:{"indeterminate":""}}):_vm._e()],1)])],1),_vm._v(" "),(_vm.product)?_c('v-ons-list',[_c('v-ons-list-header',[_vm._v("Product information")]),_vm._v(" "),_c('v-ons-list-item',[_c('div',{staticClass:"center label"},[_vm._v("EAN")]),_vm._v(" "),_c('div',{staticClass:"right"},[_vm._v(_vm._s(_vm.product.ean))])]),_vm._v(" "),(_vm.product.foreignId)?_c('v-ons-list-item',[_c('div',{staticClass:"center label"},[_vm._v("Article")]),_vm._v(" "),_c('div',{staticClass:"right"},[_vm._v(_vm._s(_vm.product.foreignId))])]):_vm._e(),_vm._v(" "),_c('v-ons-list-item',[_c('div',{staticClass:"center label"},[_vm._v("Name")]),_vm._v(" "),_c('div',{staticClass:"right"},[_vm._v(_vm._s(_vm.product.productName))])]),_vm._v(" "),_c('v-ons-list-item',[_c('div',{staticClass:"center label"},[_vm._v("Location")]),_vm._v(" "),_c('div',{staticClass:"right"},[_vm._v(_vm._s(_vm.product.location?_vm.product.location.name:""))])]),_vm._v(" "),_vm._l((_vm.dataFields),function(f){return _c('v-ons-list-item',{key:f.name},[_c('div',{staticClass:"center label"},[_vm._v(_vm._s(f.displayName))]),_vm._v(" "),_c('div',{staticClass:"right"},[_vm._v(_vm._s(_vm.fieldValue(f)))])])})],2):_vm._e()],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 314:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LoginPage_vue__ = __webpack_require__(131);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d4d200bc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LoginPage_vue__ = __webpack_require__(316);
function injectStyle (ssrContext) {
  __webpack_require__(315)
}
var normalizeComponent = __webpack_require__(25)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d4d200bc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LoginPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d4d200bc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LoginPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 315:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 316:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-ons-page',[_c('v-ons-toolbar',[_c('div',{staticClass:"center"},[_vm._v("EllaFashion Login")])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('form',{staticStyle:{"padding":"0.5rem"}},[_c('v-ons-card',[_c('div',{staticClass:"content"},[_c('div',[_c('label',[_vm._v("Username")]),_vm._v(" "),_c('v-ons-input',{attrs:{"modifier":"underbar","autocomplete":"username"},model:{value:(_vm.username),callback:function ($$v) {_vm.username=$$v},expression:"username"}})],1),_vm._v(" "),_c('div',{staticClass:"field"},[_c('label',[_vm._v("Password")]),_vm._v(" "),_c('v-ons-input',{attrs:{"type":"password","modifier":"underbar","autocomplete":"current-password"},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.login($event)}},model:{value:(_vm.password),callback:function ($$v) {_vm.password=$$v},expression:"password"}})],1),_vm._v(" "),_c('div',{staticClass:"field",staticStyle:{"text-align":"right"}},[_c('v-ons-button',{on:{"click":_vm.login}},[_vm._v("Login")])],1)])]),_vm._v(" "),_c('div',{staticClass:"branding"},[_c('img',{attrs:{"src":__webpack_require__(124)}})])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 317:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_95d9852e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SplashPage_vue__ = __webpack_require__(319);
function injectStyle (ssrContext) {
  __webpack_require__(318)
}
var normalizeComponent = __webpack_require__(25)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-95d9852e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_95d9852e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SplashPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 318:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 319:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"splash"},[_c('div',{staticClass:"content"},[_c('img',{attrs:{"src":__webpack_require__(123)}}),_vm._v(" "),_c('v-ons-progress-bar',{attrs:{"indeterminate":"","disable-auto-styling":""}}),_vm._v("\n    Loading...\n  ")],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 320:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass__);






function csrfToken() {
    var match = /XSRF-TOKEN=([^;]+)/.exec(document.cookie);
    return match ? match[1] : "";
}

var Api = function () {
    function Api(url) {
        __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default()(this, Api);

        this.baseUrl = url;
        this.authorization = null;
        this.cache = {};
    }

    __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default()(Api, [{
        key: "request",
        value: function () {
            var _ref = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee(path, method, body) {
                var url, options, res, data;
                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                if (this.authorization) {
                                    _context.next = 2;
                                    break;
                                }

                                throw new Error("Unauthorized");

                            case 2:
                                url = this.baseUrl + path;
                                options = {
                                    mode: "cors",
                                    credentials: "include",
                                    headers: {
                                        "X-Requested-With": "XMLHttpRequest",
                                        "Authorization": this.authorization,
                                        "X-XSRF-TOKEN": csrfToken()
                                    }
                                };

                                if (method) {
                                    options.method = method;
                                }
                                if (body) {
                                    options.headers["Content-Type"] = "application/json";
                                    options.body = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(body);
                                }
                                _context.next = 8;
                                return fetch(url, options);

                            case 8:
                                res = _context.sent;

                                if (res.ok) {
                                    _context.next = 11;
                                    break;
                                }

                                throw Error("request failed: (" + res.status + ") " + res.statusText);

                            case 11:
                                if (!/application\/json/.test(res.headers.get("Content-Type"))) {
                                    _context.next = 15;
                                    break;
                                }

                                _context.next = 14;
                                return res.json();

                            case 14:
                                return _context.abrupt("return", _context.sent);

                            case 15:
                                if (!/text\/plain/.test(res.headers.get("Content-Type"))) {
                                    _context.next = 19;
                                    break;
                                }

                                _context.next = 18;
                                return res.text();

                            case 18:
                                return _context.abrupt("return", _context.sent);

                            case 19:
                                _context.next = 21;
                                return res.blob();

                            case 21:
                                data = _context.sent;
                                return _context.abrupt("return", data.size > 0 ? data : null);

                            case 23:
                            case "end":
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function request(_x, _x2, _x3) {
                return _ref.apply(this, arguments);
            }

            return request;
        }()
    }, {
        key: "get",
        value: function () {
            var _ref2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2(path) {
                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.next = 2;
                                return this.request(path);

                            case 2:
                                return _context2.abrupt("return", _context2.sent);

                            case 3:
                            case "end":
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function get(_x4) {
                return _ref2.apply(this, arguments);
            }

            return get;
        }()
    }, {
        key: "post",
        value: function () {
            var _ref3 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3(path, data) {
                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _context3.next = 2;
                                return this.request(path, "post", data);

                            case 2:
                                return _context3.abrupt("return", _context3.sent);

                            case 3:
                            case "end":
                                return _context3.stop();
                        }
                    }
                }, _callee3, this);
            }));

            function post(_x5, _x6) {
                return _ref3.apply(this, arguments);
            }

            return post;
        }()
    }, {
        key: "login",
        value: function () {
            var _ref4 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4(_ref5) {
                var username = _ref5.username,
                    password = _ref5.password;
                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                this.authorization = "Basic " + btoa(username + ":" + password);
                                _context4.next = 3;
                                return this.get("login");

                            case 3:
                                return _context4.abrupt("return", _context4.sent);

                            case 4:
                            case "end":
                                return _context4.stop();
                        }
                    }
                }, _callee4, this);
            }));

            function login(_x7) {
                return _ref4.apply(this, arguments);
            }

            return login;
        }()
    }, {
        key: "logout",
        value: function () {
            var _ref6 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee5() {
                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                _context5.prev = 0;
                                _context5.next = 3;
                                return this.post("logout");

                            case 3:
                                return _context5.abrupt("return", _context5.sent);

                            case 6:
                                _context5.prev = 6;
                                _context5.t0 = _context5["catch"](0);

                                console.log("logout failed", _context5.t0);

                            case 9:
                                _context5.prev = 9;

                                this.authorization = null;
                                return _context5.finish(9);

                            case 12:
                            case "end":
                                return _context5.stop();
                        }
                    }
                }, _callee5, this, [[0, 6, 9, 12]]);
            }));

            function logout() {
                return _ref6.apply(this, arguments);
            }

            return logout;
        }()
    }, {
        key: "getDisplayTypes",
        value: function () {
            var _ref7 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee6() {
                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
                    while (1) {
                        switch (_context6.prev = _context6.next) {
                            case 0:
                                if (this.cache.displayTypes) {
                                    _context6.next = 4;
                                    break;
                                }

                                _context6.next = 3;
                                return this.get("displaytype");

                            case 3:
                                this.cache.displayTypes = _context6.sent;

                            case 4:
                                return _context6.abrupt("return", this.cache.displayTypes);

                            case 5:
                            case "end":
                                return _context6.stop();
                        }
                    }
                }, _callee6, this);
            }));

            function getDisplayTypes() {
                return _ref7.apply(this, arguments);
            }

            return getDisplayTypes;
        }()
    }, {
        key: "getDisplayFields",
        value: function () {
            var _ref8 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee7() {
                var fields, dtypes, dt, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, page, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, f;

                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
                    while (1) {
                        switch (_context7.prev = _context7.next) {
                            case 0:
                                if (this.cache.displayFields) {
                                    _context7.next = 54;
                                    break;
                                }

                                fields = {};
                                _context7.next = 4;
                                return this.getDisplayTypes();

                            case 4:
                                dtypes = _context7.sent;
                                _context7.t0 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.keys(dtypes);

                            case 6:
                                if ((_context7.t1 = _context7.t0()).done) {
                                    _context7.next = 53;
                                    break;
                                }

                                dt = _context7.t1.value;
                                _iteratorNormalCompletion = true;
                                _didIteratorError = false;
                                _iteratorError = undefined;
                                _context7.prev = 11;
                                _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(dtypes[dt].pages);

                            case 13:
                                if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                                    _context7.next = 37;
                                    break;
                                }

                                page = _step.value;
                                _iteratorNormalCompletion2 = true;
                                _didIteratorError2 = false;
                                _iteratorError2 = undefined;
                                _context7.prev = 18;

                                for (_iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(page.fields); !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                                    f = _step2.value;

                                    if (f.name in fields) {
                                        fields[f.name].push(f);
                                    } else {
                                        fields[f.name] = [f];
                                    }
                                }
                                _context7.next = 26;
                                break;

                            case 22:
                                _context7.prev = 22;
                                _context7.t2 = _context7["catch"](18);
                                _didIteratorError2 = true;
                                _iteratorError2 = _context7.t2;

                            case 26:
                                _context7.prev = 26;
                                _context7.prev = 27;

                                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                                    _iterator2.return();
                                }

                            case 29:
                                _context7.prev = 29;

                                if (!_didIteratorError2) {
                                    _context7.next = 32;
                                    break;
                                }

                                throw _iteratorError2;

                            case 32:
                                return _context7.finish(29);

                            case 33:
                                return _context7.finish(26);

                            case 34:
                                _iteratorNormalCompletion = true;
                                _context7.next = 13;
                                break;

                            case 37:
                                _context7.next = 43;
                                break;

                            case 39:
                                _context7.prev = 39;
                                _context7.t3 = _context7["catch"](11);
                                _didIteratorError = true;
                                _iteratorError = _context7.t3;

                            case 43:
                                _context7.prev = 43;
                                _context7.prev = 44;

                                if (!_iteratorNormalCompletion && _iterator.return) {
                                    _iterator.return();
                                }

                            case 46:
                                _context7.prev = 46;

                                if (!_didIteratorError) {
                                    _context7.next = 49;
                                    break;
                                }

                                throw _iteratorError;

                            case 49:
                                return _context7.finish(46);

                            case 50:
                                return _context7.finish(43);

                            case 51:
                                _context7.next = 6;
                                break;

                            case 53:
                                this.cache.displayFields = fields;

                            case 54:
                                return _context7.abrupt("return", this.cache.displayFields);

                            case 55:
                            case "end":
                                return _context7.stop();
                        }
                    }
                }, _callee7, this, [[11, 39, 43, 51], [18, 22, 26, 34], [27,, 29, 33], [44,, 46, 50]]);
            }));

            function getDisplayFields() {
                return _ref8.apply(this, arguments);
            }

            return getDisplayFields;
        }()
    }, {
        key: "getDisplayPages",
        value: function () {
            var _ref9 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee8() {
                var pages, dtypes, dtid, dt, i;
                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
                    while (1) {
                        switch (_context8.prev = _context8.next) {
                            case 0:
                                pages = [];
                                _context8.next = 3;
                                return this.getDisplayTypes();

                            case 3:
                                dtypes = _context8.sent;

                                for (dtid in dtypes) {
                                    dt = dtypes[dtid];

                                    for (i = 0; i < dt.pages.length; i++) {
                                        if (i == pages.length) {
                                            pages.push(dt.pages[i].name);
                                        }
                                    }
                                }
                                return _context8.abrupt("return", pages);

                            case 6:
                            case "end":
                                return _context8.stop();
                        }
                    }
                }, _callee8, this);
            }));

            function getDisplayPages() {
                return _ref9.apply(this, arguments);
            }

            return getDisplayPages;
        }()
    }, {
        key: "getLabel",
        value: function () {
            var _ref10 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee9(id) {
                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
                    while (1) {
                        switch (_context9.prev = _context9.next) {
                            case 0:
                                _context9.next = 2;
                                return this.get("label/" + id);

                            case 2:
                                return _context9.abrupt("return", _context9.sent);

                            case 3:
                            case "end":
                                return _context9.stop();
                        }
                    }
                }, _callee9, this);
            }));

            function getLabel(_x8) {
                return _ref10.apply(this, arguments);
            }

            return getLabel;
        }()
    }, {
        key: "getProduct",
        value: function () {
            var _ref11 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee10(id) {
                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
                    while (1) {
                        switch (_context10.prev = _context10.next) {
                            case 0:
                                _context10.next = 2;
                                return this.get("product/" + id);

                            case 2:
                                return _context10.abrupt("return", _context10.sent);

                            case 3:
                            case "end":
                                return _context10.stop();
                        }
                    }
                }, _callee10, this);
            }));

            function getProduct(_x9) {
                return _ref11.apply(this, arguments);
            }

            return getProduct;
        }()
    }, {
        key: "getProductByEan",
        value: function () {
            var _ref12 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee11(ean) {
                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11) {
                    while (1) {
                        switch (_context11.prev = _context11.next) {
                            case 0:
                                _context11.next = 2;
                                return this.get("product?ean=" + ean);

                            case 2:
                                return _context11.abrupt("return", _context11.sent);

                            case 3:
                            case "end":
                                return _context11.stop();
                        }
                    }
                }, _callee11, this);
            }));

            function getProductByEan(_x10) {
                return _ref12.apply(this, arguments);
            }

            return getProductByEan;
        }()
    }, {
        key: "getLocation",
        value: function () {
            var _ref13 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee12(id) {
                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12) {
                    while (1) {
                        switch (_context12.prev = _context12.next) {
                            case 0:
                                _context12.next = 2;
                                return this.get("location/" + id);

                            case 2:
                                return _context12.abrupt("return", _context12.sent);

                            case 3:
                            case "end":
                                return _context12.stop();
                        }
                    }
                }, _callee12, this);
            }));

            function getLocation(_x11) {
                return _ref13.apply(this, arguments);
            }

            return getLocation;
        }()
    }, {
        key: "sync",
        value: function () {
            var _ref14 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee13(items) {
                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee13$(_context13) {
                    while (1) {
                        switch (_context13.prev = _context13.next) {
                            case 0:
                                _context13.next = 2;
                                return this.post("sync", items);

                            case 2:
                                return _context13.abrupt("return", _context13.sent);

                            case 3:
                            case "end":
                                return _context13.stop();
                        }
                    }
                }, _callee13, this);
            }));

            function sync(_x12) {
                return _ref14.apply(this, arguments);
            }

            return sync;
        }()
    }, {
        key: "updateLabel",
        value: function () {
            var _ref15 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee14(id) {
                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee14$(_context14) {
                    while (1) {
                        switch (_context14.prev = _context14.next) {
                            case 0:
                                _context14.next = 2;
                                return this.post("label/" + id + "/update");

                            case 2:
                                return _context14.abrupt("return", _context14.sent);

                            case 3:
                            case "end":
                                return _context14.stop();
                        }
                    }
                }, _callee14, this);
            }));

            function updateLabel(_x13) {
                return _ref15.apply(this, arguments);
            }

            return updateLabel;
        }()
    }, {
        key: "status",
        value: function () {
            var _ref16 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee15() {
                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee15$(_context15) {
                    while (1) {
                        switch (_context15.prev = _context15.next) {
                            case 0:
                                _context15.next = 2;
                                return this.get("status");

                            case 2:
                                return _context15.abrupt("return", _context15.sent);

                            case 3:
                            case "end":
                                return _context15.stop();
                        }
                    }
                }, _callee15, this);
            }));

            function status() {
                return _ref16.apply(this, arguments);
            }

            return status;
        }()
    }, {
        key: "turnPage",
        value: function () {
            var _ref17 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee16(page) {
                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee16$(_context16) {
                    while (1) {
                        switch (_context16.prev = _context16.next) {
                            case 0:
                                _context16.next = 2;
                                return this.post("page/" + page);

                            case 2:
                                return _context16.abrupt("return", _context16.sent);

                            case 3:
                            case "end":
                                return _context16.stop();
                        }
                    }
                }, _callee16, this);
            }));

            function turnPage(_x14) {
                return _ref17.apply(this, arguments);
            }

            return turnPage;
        }()
    }]);

    return Api;
}();

/* harmony default export */ __webpack_exports__["a"] = (Api);

/***/ }),

/***/ 37:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var sounds = {
    error: new Audio(__webpack_require__(293)),
    success: new Audio(__webpack_require__(294))
};

function error(vm, msg, err) {
    console.log(msg, err);
    sounds.error.play();
    return vm.$ons.notification.alert(msg, { title: "Error" });
}

function warn(vm, msg, err) {
    console.log(msg, err);
    sounds.error.play();
    return vm.$ons.notification.toast(msg, { timeout: 2000 });
}

function info(vm, msg) {
    return vm.$ons.notification.toast(msg, { timeout: 2000 });
}

function focus(el) {
    setTimeout(function () {
        var elem = document.getElementById(el);
        if (elem != null) elem.focus();
    }, 100);
}

function validateLabel(labelId) {
    return labelId.length === 9 || labelId.length === 10;
}

/* harmony default export */ __webpack_exports__["a"] = ({
    error: error, warn: warn, info: info, focus: focus, validateLabel: validateLabel, sounds: sounds
});

/***/ })

},[132]);


// WEBPACK FOOTER //
// static/js/app.8a802f35566b848be88b.js